export default "__VITE_ASSET__BQy0IF95__"